export default __webpack_public_path__ + "static/media/icon2.0244955d.svg";